// extracted by mini-css-extract-plugin
export default {"deliveredOrders":"delivered_deliveredOrders__ope3e"};